import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LocalRoutes } from './local.routing';
import { LocalComponent } from './local.component';

@NgModule({
  imports: [
    CommonModule,
    LocalRoutes
  ],
  declarations: [LocalComponent]
})
export class LocalModule { }
